export default defineNuxtPlugin(() => {
	const {accessToken, isRefreshing, refresh} = useAuthSession()

	useIntervalFn(async () => {
		if (accessToken.value?.isExpired(60) && !isRefreshing.value) {
			await refresh()
		}
		// console.info('refresh token CHECK: ', accessToken.value?.isExpired(60))
		// console.info('TOKEN: ', accessToken.value)
	}, 10000)
})
